function consoleDiff(str1, str2) {
  const lines1 = str1.split('\n');
  const lines2 = str2.split('\n');
  let pointer1 = 0, pointer2 = 0;
  const lines = [];
  const styles = [];
  while (pointer2 < lines2.length) {
    while (pointer2 < lines2.length && !(lines1.includes(lines2[pointer2], pointer1) && (pointer2 < lines2.length && lines1.includes(lines2[pointer2 + 1], pointer1 + 1)))) {
      lines.push(lines2[pointer2]);
      styles.push('2');
      ++pointer2;
    }
    let pointer11 = lines1.indexOf(lines2[pointer2], pointer1);
    if (pointer11 !== -1) {
      while (pointer1 < pointer11) {
        lines.push(lines1[pointer1++]);
        styles.push('1');
      }
      lines.push(lines2[pointer2]);
      styles.push('0');
      ++pointer1;
      ++pointer2;
    }
  }
  while (pointer1 < lines1.length) {
    lines.push(lines1[pointer1++]);
    styles.push('1');
  }
  const s = lines.map((line) => `%c${line}`).join('\n');
  console.log(s, ...styles.map((k) => ["color: black;", "color: red;", "color: green;"][k]));
}

module.exports = consoleDiff;
